import { render, staticRenderFns } from "./MultiFileUpload.vue?vue&type=template&id=b0a3305c&"
import script from "./MultiFileUpload.vue?vue&type=script&lang=js&"
export * from "./MultiFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports